// Этот файл сгенерирован @cian/swagger-generator
// не вносите в него ручные изменения, иначе они будут утеряны
/* eslint-disable */
import type { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api';
import type {
  IGetInfrastructureNearbyBlockRequest,
  TGetInfrastructureNearbyBlockModel,
  IMappers,
  TGetInfrastructureNearbyBlockResponse,
  IGetInfrastructureNearbyBlockResponse,
  IGetInfrastructureNearbyBlockResponseError,
} from './types';

export const defaultConfig: TGetInfrastructureNearbyBlockModel = {
  apiType: 'public',
  assertStatusCodes: [200, 400],
  hostType: 'api',
  method: 'GET',
  microserviceName: 'price-estimator',
  pathApi: '/v2/get-infrastructure-nearby-block/',
} as TGetInfrastructureNearbyBlockModel;

export function createGetInfrastructureNearbyBlockModel(
  parameters: IGetInfrastructureNearbyBlockRequest,
): TGetInfrastructureNearbyBlockModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IGetInfrastructureNearbyBlockOptions<TResponse200, TResponse400> {
  httpApi: IHttpApi;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse200, TResponse400>;
  parameters: IGetInfrastructureNearbyBlockRequest;
}

export async function fetchGetInfrastructureNearbyBlock<TResponse200, TResponse400>({
  httpApi,
  config,
  mappers,
  parameters,
}: IGetInfrastructureNearbyBlockOptions<TResponse200, TResponse400>): Promise<
  TGetInfrastructureNearbyBlockResponse | TResponse200 | TResponse400
> {
  const { statusCode, response, headers } = await httpApi.fetch(
    createGetInfrastructureNearbyBlockModel(parameters),
    config,
  );
  if (mappers && statusCode in mappers) {
    if (statusCode === 200) {
      return mappers[200](response as IGetInfrastructureNearbyBlockResponse);
    }
    if (statusCode === 400) {
      return mappers[400](response as IGetInfrastructureNearbyBlockResponseError);
    }
  }
  return {
    statusCode,
    response,
    headers,
  } as TGetInfrastructureNearbyBlockResponse;
}
